// Hash url for the homes result pages
const Homes = '#home-listings';

export default Homes;